import clsx from "clsx";
import styles from "./styles.module.scss";
import type { Message } from "../../../contexts/chat-log/chat-log-context";
import React from "react";

function MessageUser({
  message,
  className,
}: {
  message: Message;
  className?: string;
}) {
  return <div className={clsx(styles.message, className)} data-message-type="user">{message.model}</div>;
}

// メモ化してpropsが変わらない限り再レンダリングしない
export default React.memo(MessageUser, (prevProps, nextProps) => {
  // messageの内容が同じなら再レンダリングしない
  return prevProps.message.model === nextProps.message.model;
});
